
import React from 'react';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import ServiceCard from '@/components/ServiceCard';
import AdBanner from '@/components/AdBanner';
import GameWidget from '@/components/game/GameWidget';
import { LayoutDashboard, CreditCard, Package, Database, Clock, Wrench, Monitor, Users } from 'lucide-react';
import logo from '/lovable-uploads/40a4ee59-7714-4091-a6f7-e5ba5819fe5f.png';
import { useOnboardingContext } from '@/context/OnboardingContext';
import ResetOnboarding from '@/components/ResetOnboarding';
import AddToHomeScreen from '@/components/AddToHomeScreen';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useTranslation } from 'react-i18next';

const Index = () => {
  // Add error handling for the onboarding context
  const { userData } = useOnboardingContext() || { userData: null };
  const { t } = useTranslation();
  
  console.log('Index page - userData:', userData);
  
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-indigo-50 via-purple-50 to-pink-50">
      <NavBar 
        title={t('app.name')} 
        logo={logo} 
        colorScheme="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600" 
      />
      
      <main className="flex-1 container mx-auto px-4 py-6 pb-20 w-full max-w-full">
        <div className="sticky top-0 pt-2 pb-4 bg-gradient-to-b from-indigo-50 via-indigo-50 to-indigo-50/90 z-10">
          {/* Removed the "Que souhaitez-vous faire?" text */}
        </div>
        
        <ScrollArea className="h-[calc(100vh-190px)] pr-4 -mr-4">
          <div className="pb-20">
            {/* Game Widget - First position */}
            <GameWidget />
            
            {/* Ad Banner component to display active ads with images and page-specific targeting */}
            <AdBanner showFullImages={true} pageSlug="home" />
            
            <div className="grid grid-cols-2 gap-4 md:grid-cols-4 mt-2">
              <ServiceCard
                to="/solde"
                icon={<CreditCard size={24} />}
                title={t('home.services.balance')}
                description={t('home.services.balanceDesc')}
                color="bg-gradient-to-br from-indigo-500 to-indigo-600"
              />
              <ServiceCard
                to="/combo"
                icon={<Package size={24} />}
                title={t('home.services.combo')}
                description={t('home.services.comboDesc')}
                color="bg-gradient-to-br from-pink-500 to-pink-600"
              />
              <ServiceCard
                to="/data"
                icon={<Database size={24} />}
                title={t('home.services.data')}
                description={t('home.services.dataDesc')}
                color="bg-gradient-to-br from-purple-500 to-purple-600"
              />
              <ServiceCard
                to="/adsl"
                icon={<Monitor size={24} />}
                title={t('home.services.adsl')}
                description={t('home.services.adslDesc')}
                color="bg-gradient-to-br from-emerald-500 to-emerald-600"
              />
              <ServiceCard
                to="/ad-request"
                icon={<LayoutDashboard size={24} />}
                title={t('home.services.adRequest')}
                description={t('home.services.adRequestDesc')}
                color="bg-gradient-to-br from-gray-500 to-gray-600"
              />
              <ServiceCard
                to="/outils"
                icon={<Wrench size={24} />}
                title={t('home.services.tools')}
                description={t('home.services.toolsDesc')}
                color="bg-gradient-to-br from-amber-500 to-amber-600"
              />
              <ServiceCard
                to="/tempo"
                icon={<Clock size={24} />}
                title={t('home.services.tempo')}
                description={t('home.services.tempoDesc')}
                color="bg-gradient-to-br from-blue-500 to-blue-600"
              />
              <ServiceCard
                to="/contacts"
                icon={<Users size={24} />}
                title={t('home.services.contacts')}
                description={t('home.services.contactsDesc')}
                color="bg-gradient-to-br from-rose-500 to-rose-600"
              />
            </div>
            
            {/* The ResetOnboarding component will only render in development environment */}
            <div className="flex justify-center mt-8">
              <ResetOnboarding />
            </div>
          </div>
        </ScrollArea>
      </main>
      
      {/* Add to Home Screen Prompt */}
      <AddToHomeScreen />
      
      <Footer />
    </div>
  );
};

export default Index;
